import { render, staticRenderFns } from "./SnapshotOrders.vue?vue&type=template&id=3b73e488"
import script from "./SnapshotOrders.vue?vue&type=script&lang=js"
export * from "./SnapshotOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports